import { useGetMessagingCapabilities } from '../../../api/generated/messaging/messaging'
import type { MessagingCapabilities } from '../../../api/generated/model/messagingCapabilities'

export const MESSAGING_OFF: MessagingCapabilities = {
  level: 'off',
  can_view_inbox: false,
  can_send: false,
  can_use_internal_notes: false,
  can_claim: false,
  can_reassign: false,
  can_manage_status: false,
  can_correct_waiting: false,
  can_reply: false,
  can_create_internal_note: false,
  show_planned_channels_card: false,
}

const LEVELS = new Set(['off', 'preview', 'pilot', 'general'])

export function resolveMessagingCapabilities(
  response: unknown,
): MessagingCapabilities {
  if (
    !response ||
    typeof response !== 'object' ||
    !('status' in response) ||
    response.status !== 200 ||
    !('data' in response) ||
    !response.data ||
    typeof response.data !== 'object'
  ) {
    return MESSAGING_OFF
  }

  const data = response.data as Record<string, unknown>
  if (
    typeof data.level !== 'string' ||
    !LEVELS.has(data.level) ||
    typeof data.can_view_inbox !== 'boolean' ||
    typeof data.can_send !== 'boolean' ||
    typeof data.can_use_internal_notes !== 'boolean' ||
    typeof data.can_claim !== 'boolean' ||
    typeof data.can_reassign !== 'boolean' ||
    typeof data.can_manage_status !== 'boolean' ||
    typeof data.can_correct_waiting !== 'boolean' ||
    typeof data.can_reply !== 'boolean' ||
    typeof data.can_create_internal_note !== 'boolean' ||
    typeof data.show_planned_channels_card !== 'boolean'
  ) {
    return MESSAGING_OFF
  }

  if (data.level === 'off') {
    return MESSAGING_OFF
  }

  return {
    level: data.level as MessagingCapabilities['level'],
    can_view_inbox: data.can_view_inbox,
    can_send: data.can_send,
    can_use_internal_notes: data.can_use_internal_notes,
    can_claim: data.can_claim,
    can_reassign: data.can_reassign,
    can_manage_status: data.can_manage_status,
    can_correct_waiting: data.can_correct_waiting,
    can_reply: data.can_reply,
    can_create_internal_note: data.can_create_internal_note,
    show_planned_channels_card: data.show_planned_channels_card,
  }
}

export function useMessagingCapabilities(): MessagingCapabilities {
  const query = useGetMessagingCapabilities({
    query: {
      retry: false,
      staleTime: 60_000,
    },
  })

  return resolveMessagingCapabilities(query.data)
}
